// some common methos
import moment from 'moment'
import cookies from 'js-cookie'
const UTILS = {
  cookies,
  formatDate: time => {
    return moment(time).format('YYYY-MM-DD')
  },
  getUrlParam: (url, property) => {
    if (!url && !property) return
    let info
    // eslint-disable-next-line
    let urlArr = url.split(/[\?|&|\/?#\/]/g)
    urlArr = urlArr.slice(1, urlArr.length)
    for (let i = 0, j = urlArr.length; i < j; i++) {
      let o = urlArr[i].split('=')
      if (o[0] + '' === property + '') {
        info = o[1]
        break
      }
    }
    return info
  },
  strlen: str => {
    let len = 0
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i)
      // 单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
        len++
      } else {
        len += 2
      }
    }
    return len
  },
  mergeObj: (ObjA, objB) => {
    Object.keys(objB).forEach((key) => {
      ObjA[key] = objB[key]
    })
  },
  getActivityType: value => {
    let type
    switch (value) {
      case 1:
        type = this.$t('w142')
        break
      case 1 << 1:
        type = this.$t('w249')
        break
      case 1 << 2:
        type = this.$t('w203')
        break
      case 1 << 3:
        type = this.$t('w89')
        break
      case 1 << 4:
        type = this.$t('w676')
        break
      case 1 << 5:
        type = this.$t('w677')
        break
      case 1 << 6:
        type = this.$t('w678')
        break
    }
    return type
  }
}
export default UTILS



// WEBPACK FOOTER //
// ./src/utils/utils.js